import { Steps } from "antd";
import Styled from "styled-components";

const FooterModalWrapper = Styled.div`
	display: flex;
	flex-direction:column;
	align-items:center;
	width: 300px;
	text-align: "center";
	.noregistry__ticket-label{
		cursor: pointer;
		font-weight:700;
		text-decoration: underline;
		color:#145AB4
		
	}`;

const WizardWrapper = Styled.div`
    width: 100%;
    margin: 0 auto;
    @media(min-width: 780px) {
        width: 70%;
    }
   
`;
const StepWrapper = Styled.div`
    display: flex;
    flex-direction: column;
    align-items:center;
    
`;
const StepsContent = Styled.div`
  width: 100%;
  padding-top: 40px;
  text-align: center;
}
`;
const StepsActions = Styled.div`
     display: flex;
    justify-content: center;

`;

const StepsView = Styled(Steps)`
    width: 50%;
`;
export {
	WizardWrapper,
	StepsContent,
	StepsActions,
	StepWrapper,
	StepsView,
	FooterModalWrapper,
};
